const filterRender = (val) => {
  if (!val && val !== 0) {
    return '--';
  }

  return val;
};

export function setShipTable () {
  const shipColumns = [
    {
      field: 'goodsCode',
      title: '商品编码',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.goodsCode);
      },
    },
    {
      field: 'goodsName',
      title: '商品名称',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.goodsName);
      },
    },
    {
      field: 'specsNo',
      title: '规格型号',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.specsNo);
      },
    },
    {
      field: 'brandName',
      title: '品牌名称',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.brandName);
      },
    },
    {
      field: 'producer',
      title: '生产商',
      tooltip: true,
      minWidth: '180px',
      formatter: () => {
        return '-';
      },
    },
    {
      field: 'isMedichair',
      title: '是否医疗件',
      tooltip: true,
      minWidth: '110px',
      formatter: ({ row }) => {
        return row.isMedichair === 1 ? '是' : '否';
      },
    },
    {
      field: 'unitOfMsment',
      title: '计量单位',
      tooltip: true,
      minWidth: '100px',
      formatter: ({ row }) => {
        return filterRender(row.unitOfMsment);
      },
    },
    {
      field: 'noShippedNum',
      title: '未发货数量',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.noShippedNum);
      },
    },
    {
      field: 'orderCode',
      title: '销售单号',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.orderCode);
      },
    },
  ];

  const item = {
    field: 'consumeNum',
    title: '本次发货数量',
    tooltip: true,
    minWidth: '150px',
    fixed: 'right',
  };

  if (this.isDirect === 1) {
    item.slots = {
      default: ({row, rowIndex}, h) => {
        return [h('span', {
          class: ['num', row.warn ? 'warn' : ''],
          on: {
            click: () => {
              this.handleDeliveryGoods(row, rowIndex);
            },
          },
        }, row.consumeNum)];
      },
    };
  } else if (this.isDirect === 2) {
    item.editRender = { name: '$input', props: { type: 'integer', min: 0, max: 99999999999, placeholder: '请输入销售数量' } };
  }

  shipColumns.push(item);

  return shipColumns;
}

export function setShipTable2 () {
  const shipColumns = [
    {
      field: 'skuCode',
      title: '商品编码',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.skuCode);
      },
    },
    {
      field: 'goodsName',
      title: '商品名称',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.goodsName);
      },
    },
    {
      field: 'brandName',
      title: '品牌名称',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.brandName);
      },
    },
    {
      field: 'model',
      title: '型号',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.model);
      },
    },
    {
      field: 'specification',
      title: '规格',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.specification);
      },
    },
    {
      field: 'manufacturer',
      title: '生产商',
      tooltip: true,
      minWidth: '180px',
      formatter: () => {
        return '-';
      },
    },
    {
      field: 'medicalFlag',
      title: '是否医疗件',
      tooltip: true,
      minWidth: '110px',
      formatter: ({ row }) => {
        return row.medicalFlag ? '是' : '否';
      },
    },
    {
      field: 'unitName',
      title: '计量单位',
      tooltip: true,
      minWidth: '100px',
      formatter: ({ row }) => {
        return filterRender(row.unitName);
      },
    },
    {
      field: 'unDeliveryQuantity',
      title: '未发货数量',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.unDeliveryQuantity);
      },
    },
    {
      field: 'orderCode',
      title: '销售单号',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.orderCode);
      },
    },
  ];

  const item = {
    field: 'consumeNum',
    title: '本次发货数量',
    tooltip: true,
    minWidth: '150px',
    fixed: 'right',
  };

  item.slots = {
    default: ({row, rowIndex}, h) => {
      return [h('span', {
        class: ['num', row.warn ? 'warn' : ''],
        on: {
          click: () => {
            this.handleDeliveryGoods2(row, rowIndex);
          },
        },
      }, row.consumeNum)];
    },
  };

  shipColumns.push(item);

  return shipColumns;
}

export function setDeliveryGoodsColumn (isMedichair) {
  const frontCols = [
    {
      tooltip: true,
      title: '',
      minWidth: '100px',
      align: 'center',
      width: '',
      fixed: 'left',
      type: 'checkbox',
      prop: '',
    },
    {
      title: '商品图片',
      prop: 'image',
      tooltip: true,
      minWidth: '120px',
      slots: { default: 'imageList'},
    },
    {
      field: 'goodsCode',
      title: '商品编码',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.goodsCode);
      },
    },
    {
      field: 'goodsName',
      title: '商品名称',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.goodsName);
      },
    },
    {
      field: 'brandName',
      title: '品牌名称',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.brandName);
      },
    },
    {
      field: 'specsNo',
      title: '规格型号',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.specsNo);
      },
    },
    {
      field: 'producer',
      title: '生产商',
      tooltip: true,
      minWidth: '180px',
      formatter: () => {
        return '-';
      },
    },
    {
      field: 'deliveryNum',
      title: '发货数量',
      tooltip: true,
      minWidth: '100px',
      formatter: () => {
        return '1';
      },
    },
    {
      field: 'productionDate',
      title: '生产日期',
      minWidth: '180px',
      // editRender: { name: '$input', props: { type: 'date', placeholder: '请选择生产日期' } },
      slots: { header: 'headerProductionDate', default: 'productionDate'},
    },
    {
      field: 'expiryDate',
      title: '失效日期',
      minWidth: '180px',
      // editRender: { name: '$input', props: { type: 'date', placeholder: '请选择失效日期' } },
      slots: { header: 'headerExpiryDate', default: 'expiryDate'},
    },
  ];

  const endCols = [
    {
      field: 'isMedichair',
      title: '是否医疗件',
      tooltip: true,
      minWidth: '110px',
      formatter: ({ row }) => {
        return row.isMedichair === 1 ? '是' : '否';
      },
    },
    {
      field: 'certificateNumber',
      title: '注册证号',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.certificateNumber);
      },
    },
    {
      title: '本次发货数量',
      fixed: 'right',
      minWidth: '140px',
      slots: {
        default: ({rowIndex}, h) => {
          return [h('span', {
            class: 'num',
            on: {
              click: () => {
                let type = rowIndex ? 'reduce' : 'add';
                this.operateDeliveryGoods(type, rowIndex);
              },
            },
          }, !rowIndex ? '+' : '-')];
        },
      },
    },
  ];

  let columns = [];

  if (isMedichair === 1) {
    columns = [
      ...frontCols,
      {
        field: 'productionBatchNumber',
        title: '生产批次号',
        minWidth: '180px',
        // editRender: { name: '$input', props: { placeholder: '请输入生产批次号' } },
        slots: { header: 'headerBatchNumber', default: 'productionBatchNumber'},
      },
      {
        field: 'productionSerialNumber',
        title: '生产序列号',
        minWidth: '180px',
        // editRender: { name: '$input', props: { placeholder: '请输入生产序列号' } },
        slots: { header: 'headerSerialNumber', default: 'productionSerialNumber'},
      },
      ...endCols,
    ];
  } else {
    columns = [
      ...frontCols,
      ...endCols,
    ];
  }

  columns.forEach(v => {
    if (!v.minWidth) {
      v.minWidth = `${v.title.length * 16 + 20}px`;
    }
  });

  return columns;
}

export function setDeliveryGoodsColumn2 () {
  let columns = [
    {
      tooltip: true,
      title: '',
      minWidth: '100px',
      align: 'center',
      width: '',
      fixed: 'left',
      type: 'checkbox',
      prop: '',
    },
    {
      title: '商品图片',
      prop: 'image',
      tooltip: true,
      minWidth: '120px',
      slots: { default: 'imageList'},
    },
    {
      field: 'skuCode',
      title: '商品编码',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.skuCode);
      },
    },
    {
      field: 'goodsName',
      title: '商品名称',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.goodsName);
      },
    },
    {
      field: 'brandName',
      title: '品牌名称',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.brandName);
      },
    },
    {
      field: 'model',
      title: '型号',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.model);
      },
    },
    {
      field: 'specification',
      title: '规格',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.specification);
      },
    },
    {
      field: 'producer',
      title: '生产商',
      tooltip: true,
      minWidth: '180px',
      formatter: () => {
        return '-';
      },
    },
    {
      field: 'quantity',
      title: '发货数量',
      tooltip: true,
      minWidth: '100px',
    },
    {
      field: 'productionDate',
      title: '生产日期',
      minWidth: '180px',
      // editRender: { name: '$input', props: { type: 'date', placeholder: '请选择生产日期' } },
      slots: { header: 'headerProductionDate', default: 'productionDate'},
    },
    {
      field: 'expiryDate',
      title: '失效日期',
      minWidth: '180px',
      // editRender: { name: '$input', props: { type: 'date', placeholder: '请选择失效日期' } },
      slots: { header: 'headerExpiryDate', default: 'expiryDate'},
    },
    {
      field: 'medicalFlag',
      title: '是否医疗件',
      tooltip: true,
      minWidth: '110px',
      formatter: ({ row }) => {
        return row.medicalFlag ? '是' : '否';
      },
    },
    {
      field: 'batchNo',
      title: '生产批次号',
      tooltip: true,
      minWidth: '130px',
    },
    {
      field: 'serialNo',
      title: '生产序列号',
      tooltip: true,
      minWidth: '130px',
    },
    {
      field: 'certificateNumber',
      title: '注册证号',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.certificateNumber);
      },
    },
    {
      title: '本次发货数量',
      fixed: 'right',
      minWidth: '140px',
      slots: {
        default: ({rowIndex}, h) => {
          return [h('span', {
            class: 'num',
            on: {
              click: () => {
                let type = rowIndex ? 'reduce' : 'add';
                this.operateDeliveryGoods2(type, rowIndex);
              },
            },
          }, !rowIndex ? '+' : '-')];
        },
      },
    },
  ];

  columns.forEach(v => {
    if (!v.minWidth) {
      v.minWidth = `${v.title.length * 16 + 20}px`;
    }
  });

  return columns;
}
